import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useBookAssignees = (bookId, shouldFetch = true) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get(`books/${bookId}/assignees`);
		return res.data?.data;
	};

	return useQuery(["book-assignees", bookId], () => fetch(), {
		...fetchConfig,
		enabled: Boolean(shouldFetch && bookId),
	});
};

export default useBookAssignees;
